import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ICategoriaProduto } from '../model';

@Injectable()
export class CategoriaProdutoService extends EntityService<ICategoriaProduto> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'categoria_produto'
      }
    );
  }
}
